<div class="layout-container">
  <div class="side-header-container">
    <app-side-nav></app-side-nav>
    <!--<div class="header">
      <h5>Clinical Trial Management System</h5>
      <img src="assets/logo/logo.jpg" alt="Logo" class="logo">
      <h6 class="sub-header">Target Institute of Medical Education & Research Pvt. Ltd.</h6>
      <!--<button class="user-login-btn">User Login</button>--
      
    </div>-->
  </div>
<div class="main-content">
<!--<button type="button" class="btn btn" (click)="goBack()" style="color: blue;" >
  <img src="assets/img/icons/back.png" alt="Back" style="width: 16px; height: 16px; margin-right: 5px; color: blue;"> Back
</button>-->

  
  
  
  
<div class="study-buttons">
  <button class="study-btn" >Total Study</button>
  <button class="study-btn" >Ongoing Studies</button>
  <button class="study-btn" >Completed Studies</button>
  
  <button class="study-btn" >Study Code</button>
  <button class="study-btn" >Study Name</button>
  
</div>

<div class="study-boxes">
  <div class="study-box" >{{ totalStudies.totalStudies }}</div>
  <div class="study-box" >{{ totalStudies.ongoingStudies }}</div>
  <div class="study-box" >{{ totalStudies.completedStudies }}</div>
  
  <div class="study-box">
    <div class="dropdown-container">
      <!-- Trigger input box -->
      <input
        type="text"
        placeholder="Select Study Code"
        class="study-code-box"
        [value]="selectedStudy"
        (click)="toggleDropdown()"
        readonly
      />

      <!-- Dropdown list -->
      <div
        class="dropdown-list"
        *ngIf="isDropdownVisible"
      >
        <!-- Search bar -->
        <input
          type="text"
          placeholder="Search Study Code"
          class="search-bar"
          [(ngModel)]="searchText"
          (ngModelChange)="filterStudyCodes()"
        />
        <!-- List of filtered study codes -->
        <ul>
          <li
            *ngFor="let code of filteredStudyCodes"
            (click)="selectStudy(code)"
          >
            {{ code }}
          </li>
        </ul>
      </div>
    </div>
  </div>

  <div class="study-box" >{{ studyName }}</div>
</div>

  <!--<div class="button-container">
    <button (click)="goToDashboard()" class="management-btn">User Management</button>
    <button (click)="goToDashboard1()" class="management-btn">Study Management</button>
  </div>-->
  
  <div class="dashboard-container">
    <!-- Left Side: Tables -->
    <div class="left-section">
      <!-- Big Table -->
      <div class="full-width-table">
        <table class="study-table">
          <thead>
            <tr>
              <th rowspan="2">Study Site</th>
              <th colspan="5">Recruitment Running Status</th>
            </tr>
            <tr>
              <th>Screening</th>
              <th>Randomization</th>
              <th>Dropout</th>
              <th>Ongoing</th>
              <th>Completed</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let site of uniqueSites">
              <td>{{ site }}</td>
              <td>{{ getValue(site, 68) }}</td>
              <td>{{ getValue(site, 69) }}</td>
              <td>{{ getValue(site, 71) }}</td>
              <td>{{ getValue(site, 86) }}</td>
              <td>{{ getValue(site, 72) }}</td>
            </tr>
          </tbody>
        </table>
      </div>
  
      <!-- Small Tables -->
      <div class="small-tables-container">
        <div class="small-table">
          <table class="study-table">
            <thead>
              <tr>
                <th>Study Site</th>
                <th>SAE Status (Total No)</th>
                <th>AE Status (Total No)</th>
                <th>Protocol Deviation Status</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let site of uniqueSites">
                <td>{{ site }}</td>
                <td>{{ getValue(site, 74) }}</td>
                <td>{{ getValue(site, 89) }}</td>
                <td>{{ getValue(site, 92) }}</td>

              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  
    <!-- Right Side: Charts -->
    <div class="right-section">
      <!-- Pie Chart -->
      <div class="pie-chart">
        <h5>Study Recruitment</h5>
        <canvas id="mainPieChart"></canvas>
      </div>
  
      <!-- Bar Chart -->
      <div class="bargraph-container">
        <h5>Study Recruitment Status</h5>
        <canvas id="barChart" width="800" height="640"></canvas>
      </div>
    </div>
  </div>
  